'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Svg = require('./Svg');

var _Svg2 = _interopRequireDefault(_Svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Pocket = function Pocket(_ref) {
  var width = _ref.width,
      link = _ref.link,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['width', 'link', 'title']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ title: title, width: width, href: link, onClick: link ? undefined : _Actions2.default['pocket']
    }, props),
    _react2.default.createElement(
      _Svg2.default,
      _extends({ xmlns: 'http://www.w3.org/2000/svg', width: width, height: width, viewBox: '0 0 33 33' }, props),
      _react2.default.createElement(
        'title',
        null,
        title,
        ' button'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'transparent', fillRule: 'evenodd', transform: 'translate(.809 1)' },
        _react2.default.createElement('ellipse', { cx: '16.071', cy: '15.606', rx: '15.599', ry: '15.606' }),
        _react2.default.createElement('path', { d: 'M20.354 15.086L16.41 19.03c-.2.2-.463.3-.726.297a1.01 1.01 0 0 1-.752-.297l-3.943-3.945a1.015 1.015 0 0 1 1.434-1.435l3.249 3.25 3.249-3.25a1.014 1.014 0 1 1 1.433 1.435zm2.954-3.607c0-1.116-.899-2.02-2.005-2.02H10.04a2.013 2.013 0 0 0-2.004 2.02v5.598c0 .104.008.206.023.305-.016.15-.023.301-.023.452 0 3.21 3.418 5.811 7.636 5.811 4.217 0 7.636-2.602 7.636-5.81 0-.153-.009-.304-.024-.453.015-.1.024-.201.024-.305v-5.598z' })
      )
    )
  );
};

Pocket.defaultProps = {
  title: "Save to Pocket"
};

exports.default = Pocket;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Pocket.js
// module id = 444
// module chunks = 168707334958949